/* Drukke Mama's — stopt externe video's (YouTube/Vimeo) die niet meer de
   actieve galerij-media zijn. Dawn's media-gallery.js roept bij een media-
   wissel netjes window.pauseAllMedia() aan, en dat pauzeert <video>-elementen
   prima — maar het pauze-postMessage naar YouTube/Vimeo-iframes wordt door de
   speler genegeerd zodra de 'origin'-parameter in de embed-URL (het primaire
   shopdomein) niet overeenkomt met de host waarop de shop bekeken wordt
   (preview/dev). Daarom laden we het iframe van een niet-actieve slide hier
   volledig uit: de deferred-media valt terug op zijn poster en Dawn laadt hem
   bij herselectie gewoon opnieuw uit zijn <template>. Geen wijzigingen aan
   Dawn's eigen JS. */

(function () {
  function unloadInactiveExternalVideos(gallery) {
    gallery
      .querySelectorAll('.product__media-item:not(.is-active) .deferred-media[loaded]')
      .forEach(function (deferredMedia) {
        var frame = deferredMedia.querySelector('iframe.js-youtube, iframe.js-vimeo');
        if (!frame) return;
        frame.remove();
        deferredMedia.removeAttribute('loaded');
      });
  }

  function watchGallery(gallery) {
    if (gallery.dmMediaPauseObserved) return;
    gallery.dmMediaPauseObserved = true;
    var observer = new MutationObserver(function (mutations) {
      var switched = mutations.some(function (mutation) {
        return (
          mutation.target.classList &&
          mutation.target.classList.contains('product__media-item') &&
          !mutation.target.classList.contains('is-active')
        );
      });
      if (switched) unloadInactiveExternalVideos(gallery);
    });
    observer.observe(gallery, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(watchGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
